export const colors = {
  primary: {
    50: '#FFF5F5',
    100: '#ffdbdb',
    200: '#ff9292',
    300: '#FF4949',
    400: '#FF3535',
    500: '#ff0000',
    600: '#b60000',
  },
  cyan: {
    50: '#F0FDFE',
    100: '#DEFAFC',
    200: '#9BF1F6',
    300: '#58E8F0',
    400: '#15DFEA',
    500: '#14D4DE',
    600: '#0FA0A7',
  },
  gray: {
    100: '#eff2f5',
    200: '#cfd8e2',
    300: '#afbecf',
    400: '#90a4bc',
    500: '#7089a9',
    600: '#56708f',
    700: '#43576f',
    800: '#2F3D4E',
    900: '#1d2530',
    1000: '#0a0c10',
  },
  success: '#10b981',
  warning: '#f59e0b',
  error: '#ef4444',
  info: '#FF4949',
  white: '#ffffff',
  transparent: 'rgba(0, 0, 0, 0)',
};